const BaseView = require('./view').default;
const seatsPostBookingUtils = require('../../../utils/postbooking/js/seats');

module.exports = BaseView.extend({
    uiStrategyConst: {
        titleClasses: 'odf-text-xl',
        productInfoTextClass: 'odf-text-sm',
    },
    providerABs: {
        '1A': Odigeo.AB.isPostBookingSeatsSB3OF21ADesktop,
        'TP': Odigeo.AB.isPostBookingSeatsSB3OF2TPDesktop,
        'TF': Odigeo.AB.isPostBookingSeatsSB3OF2TFDesktop,
    },
    shouldDisplayOF2Seats: (bookingInfo, providerABs) => {
        return Odigeo.AB.isPostBookingSeatsSB3OF2Desktop || seatsPostBookingUtils.areAllProvidersActiveOF2(bookingInfo, providerABs);
    },
});
